import React from 'react'

import Header from '../../components/HeaderMenuContent'
import Button from '../../components/Button'
import { HiInformationCircle } from 'react-icons/hi'

import { Container, ContainerContent, Details, LogoVoo, Duration, DataContainer, Line, DivParagraphRight, DivParagraphLeft, Bar } from './styles'


export default function FlightDetails() {

    return (
        <>
            <Header />
            <Container>
                <Details> Detalhe do voo </Details>
                <ContainerContent>
                    <LogoVoo>
                        <img src="https://ll-qa.s3.amazonaws.com/media/aereo/JJ.png" />
                        <p>Classe econômica</p>
                    </LogoVoo>
                    <Duration>Duração: 1h30min</Duration>
                    <DataContainer>
                        <DivParagraphRight>
                            <p>
                                Saída
                                <span>Seg. 18/04/2021</span>
                            </p>
                            <p>
                                Horário <span>10h00</span>
                            </p>
                            <p>
                                Origem <span>GRU <span className="border"></span> São Paulo</span>
                            </p>
                        </DivParagraphRight>
                        <Line></Line>
                        <DivParagraphLeft>
                            <p>
                                Chegada
                                <span>Seg. 18/04/2021</span>
                            </p>
                            <p>
                                Horário <span>10h00</span>
                            </p>
                            <p>
                                Origem <span>GRU <span className="border"></span> São Paulo</span>
                            </p>
                        </DivParagraphLeft>
                    </DataContainer>
                    <Bar> <p><HiInformationCircle className="icon"/>Inclui bagagem de mão</p></Bar>
                    <Button>SELECIONAR VOO</Button>
                </ContainerContent>
            </Container>
        </>
    )
}